import { useEffect, useState, useRef } from "react";
import "./index.scss";
import { Toast } from "primereact/toast";
import { useProofScopeURL } from "../../ProofScope/ViewFiles";
import { useDispatch, useSelector } from "react-redux";
import {
  getEnvironmentFromURL,
  sanitizeFileName,
  replaceSpecialChars,
  fetchExtractedAnnotations,
} from "../../../utils";
import { DownloadAnnotation } from "../../ProofScope/ExportXFDFGeneration";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { changeDateFormat, displayStateValuesTaskDetail } from "../../../utils";
import ApprovedIcon from "../../../assets/images/ApprovedIcon.svg";
import RejectedIcon from "../../../assets/images/RejectedIcon.svg";
import _, { isArray, isNull } from "lodash";
import { Dialog } from "primereact/dialog";
import { getTaskDetails } from "../../../store/actions/taskDetailAction";
import { downloadAzureFileShare } from "../../../apis/downloadProofscopeAzureFs";
import {  useParams, useNavigate } from "react-router-dom";
import FileUploadManager from "../../common/FileUploadManager/FileUploadManager";
import FileListContainer from "../../common/FileUploadManager/FileListContainer";
import { getSupplierFileInfo, getCopyXmlSupplierFileInfo } from "../../../apis/getSupplierFileInfo";
import useAzureUploadFolderStructure from "../../../hooks/useAzureUploadFolderStructure";
import { Message } from "primereact/message";
import UploadBriefingDocuments from "../DesignJobs/UploadBriefingDocuments";
import plusCollapseImg from "../../../assets/images/plusCollapse.svg";
import 'primeicons/primeicons.css';
import { Container } from "react-bootstrap";
import { Button } from "react-bootstrap";

const UploadDesignIntentProofscope = ({
  Design_Intent_Name,
  upload,
  approve,
  approvalStatus,
  file_name,
  setformattedValue,
  setFileName,
  fileName,
  setAzureFile,
  azureFile,
  setAzureFileUploadMsg,
  item,
  buName,
  taskFolder,
  TaskID,
  ProjectID,
  viewFileName,
  setViewFileName,
  comments,
  setComments,
  tableData,
  setTableData,
  setInitialTableData,
  setAllRowsEdited,
  DropDownValuesData,
  setFileDetails,
  setVersion,
  version,
  toShowReferenceDocuments = false,
  toShowORDA = false,
  loading,
  azureFileUploadMsg,
  thumbnailErrorMsg,
  setPageEdited,
  pageEdited,
  rejected,
  checkReadWriteAccess,
  setFormObjects,
  setFileUploaded,
  InitialTableData,
  isLoading,
  setIsLoading,
  showApprovedTaskList = false,
  otherRefernceDocsForUI = [],
  onORDAFileUpload,
  onORDAFileClear,
  otherRDAddNewEmptyDesign,
  azureSubFolder,
  isAwmCicMatrixToggle = false,
}) => {
  const toast = useRef(null);
  let { page1, page2, pageType } = useParams();
  const navigate = useNavigate();
  setViewFileName(item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name);
  const dispatch = useDispatch();

  const [totalSize, setTotalSize] = useState(0);
  const { viewProofScopeFile, loadProofscope, isError, message, fileContent, setFileContent } =
    useProofScopeURL();
  const [assignee, setAssignee] = useState("");
  const [userAssigned, setUserAssigned] = useState("");
  const [fileExtMsg, setFileExtMsg] = useState("");
  const [visible, setVisible] = useState(false);
  const [apporovalId, setApprovalId] = useState("");
  const [apporovalTaskId, setApprovalTaskId] = useState("");
  const folderStructure = useAzureUploadFolderStructure(taskFolder, version, false);
  const otherReferenceDocs = "Other Reference Documents & Assets";

  const [referenceDocumentsList, setReferenceDocumentsList] = useState({});
  const [rejectionReasonError, setRejectionReasonError] = useState(null);

  const [approvedTaskList, setApprovedTaskList] = useState(null);

  let CicCicmIsMarkupPresent = "No";
  const checkCicCicmIsMarkupPresent = (isAwmCicMatrixToggle && TaskID.includes("ACICMatrix")) ;
  
  const approvedTaskListHeader = [
    { field: "Role", header: "Role" },
    { field: "Assignee", header: "Owner" },
    { field: "Status", header: "Task Status" },
  ];
  const AzureSubFolder = azureSubFolder ? azureSubFolder : "GA Brief";

  const dynamicColumns_approvedTaskList = () => {
    let columns;
    columns = approvedTaskListHeader;

    return [
      columns.map((col, i) => (
        <Column
          key={i}
          field={col?.field}
          header={col?.header}
          body={renderMappingBody_approvedTaskList}
        />
      )),
    ];
  };

  const renderMappingBody_approvedTaskList = (options, rowData) => {
    let { field } = rowData;

    return (
      <>
        {field === "Role" && <span>{options[field]}</span>}
        {field === "Assignee" && <span>{options[field]}</span>}
        {field === "Status" && <>{displayStateValuesTaskDetail(options[field])}</>}
      </>
    );
  };

  const {
    userDetails: { UserGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const User = useSelector((state) => state.UserReducer);
  const userInformation = User.userInformation;
  const userAccessPayLoad = {
    ArtworkAgilityPage: {
      UserId: userInformation?.userid,
      ProjectID: ProjectID,
      UserGroup: UserGroup,
    },
  };

  let columns = [
    { field: "version", header: "Version" },
    { field: "markUpDate", header: "Date" },
    { field: "owner", header: "Owner" },
    { field: "content", header: "Markup" },
  ];

  if (taskFolder === "CIC" || taskFolder === "CICMATRIX") {
    columns = [
      { field: "version", header: "Version" },
      { field: "markUpDate", header: "Date" },
      { field: "owner", header: "Owner" },
      { field: "content", header: "Markup" },
    ];
  }

  
  const DesignJobDetails = item?.DesignJobDetails?.[0];

  const folderStructureWithoutVersion = useAzureUploadFolderStructure(taskFolder, version, false);

  // AWM-3059: Function to get the object with the highest versionNumber and check fileName
  function findLatestFile(files) {
    // Find the object with the highest versionNumber
    const latestFile = files?.reduce((latest, current) => {
        return current.versionNumber > latest.versionNumber ? current : latest;
      }, files[0]);

      // Check if the fileName without the extension matches viewFileName
      const fileNameWithoutExtension = replaceSpecialChars(latestFile?.fileName)
        ?.split(".")
        ?.slice(0, -1)
        ?.join(".");
      if (
        fileNameWithoutExtension ===
        replaceSpecialChars(item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name)
          ?.split(".")
          ?.slice(0, -1)
          ?.join(".")
      ) {
        return [latestFile];
      }

    return null; // Return null if the condition is not met
  }

  //AWM-3472
  const isArrayOfEmptyObjects = (data) => {
    for (let item of data) {
      if (Object.keys(item).length > 0) {
        return false; // Return false if an object with data is found
      }
    }
    return true; // Return true if all objects are empty
  };

  useEffect(() => {
    if (!loading && item) {
      async function fetchSupplierFileInfo() {
        let poaNumbers = [];

        let GABriefFiles = {};
        let OtherReferenceDocuments = {};
        let RDTFileDetailsList = {};
        let CCDFileDetailsList = [];
        let IQFileDetailsList = [];
        let CPTFileDetailsList = [];

        if (item?.CICDetails) {
          poaNumbers = item?.CICDetails?.map((detail) => detail?.POANumber);
          poaNumbers = poaNumbers[0] === undefined ? item?.CICMatrixDetails?.map((detail) => detail?.POANumber) : poaNumbers;

          if (
            item?.CICDetails?.[0]?.GABriefFiles?.length &&
            Object.keys(item?.CICDetails?.[0]?.GABriefFiles?.[0]).length
          ) {
            GABriefFiles = item?.CICDetails?.[0]?.GABriefFiles;
          }

          if (
            item?.CICDetails?.[0]?.OtherReferenceDocuments?.length &&
            Object.keys(item?.CICDetails?.[0]?.OtherReferenceDocuments?.[0]).length
          ) {
            OtherReferenceDocuments = item?.CICDetails?.[0]?.OtherReferenceDocuments;
          }

          item?.CICDetails?.[0]?.RDTFileDetailsList?.length &&
            Object.keys(item?.CICDetails?.[0]?.RDTFileDetailsList?.[0]).length &&
            item?.CICDetails?.[0]?.RDTFileDetailsList?.map((obj, index) => {
              RDTFileDetailsList[`${Object.keys(obj)[0]}${index}`] = obj[Object.keys(obj)[0]];
            });

          if (
            item?.CICDetails?.[0]?.CCDFileDetailsList?.length &&
            item?.CICDetails?.[0]?.CCDFileDetailsList?.[0]?.CCDDetails &&
            Object.keys(item?.CICDetails?.[0]?.CCDFileDetailsList?.[0]?.CCDDetails).length
          ) {
            CCDFileDetailsList = item?.CICDetails?.[0]?.CCDFileDetailsList?.[0]?.CCDDetails;
          }

          if (
            item?.CICDetails?.[0]?.IQFileDetailsList?.length &&
            item?.CICDetails?.[0]?.IQFileDetailsList?.[0]?.IQDetails &&
            Object.keys(item?.CICDetails?.[0]?.IQFileDetailsList?.[0]?.IQDetails).length
          ) {
            IQFileDetailsList = item?.CICDetails?.[0]?.IQFileDetailsList?.[0]?.IQDetails;
          }

          if (
            item?.CICDetails?.[0]?.CPTFileDetailsList?.length &&
            item?.CICDetails?.[0]?.CPTFileDetailsList?.[0]?.CPTDetails &&
            Object.keys(item?.CICDetails?.[0]?.CPTFileDetailsList?.[0]?.CPTDetails).length
          ) {
            CPTFileDetailsList = item?.CICDetails?.[0]?.CPTFileDetailsList?.[0]?.CPTDetails;
          }
        } else if (item?.CICMatrixDetails) {
          poaNumbers = item?.CICMatrixDetails?.map((detail) => detail?.POANumber);

          item?.GABriefFiles?.length &&
            !isArrayOfEmptyObjects(item?.GABriefFiles) && //AWM-3472
            // Object.keys(item?.GABriefFiles?.[0]).length &&
            item?.GABriefFiles?.map((obj, index) => {
              GABriefFiles[`${Object.keys(obj)[0]}${index}`] = obj[Object.keys(obj)[0]];
            });

          item?.OtherReferenceDocuments?.length &&
            !isArrayOfEmptyObjects(item?.OtherReferenceDocuments) && //AWM-3472
            // Object.keys(item?.OtherReferenceDocuments?.[0]).length &&
            item?.OtherReferenceDocuments?.map((obj, index) => {
              OtherReferenceDocuments[`${Object.keys(obj)[0]}${index}`] = obj[Object.keys(obj)[0]];
            });

          item?.RDTFileDetailsList?.length &&
            !isArrayOfEmptyObjects(item?.RDTFileDetailsList) && //AWM-3472
            // Object.keys(item?.RDTFileDetailsList?.[0]).length &&
            item?.RDTFileDetailsList?.map((obj, index) => {
              RDTFileDetailsList[`${Object.keys(obj)[0]}${index}`] = obj[Object.keys(obj)[0]];
            });

          if (
            item?.CICDetails?.[0]?.CCDFileDetailsList?.length &&
            Object.keys(item?.CICDetails?.[0]?.CCDFileDetailsList?.[0]?.CCDDetails).length
          ) {
            CCDFileDetailsList = item?.CICDetails?.[0]?.CCDFileDetailsList?.[0]?.CCDDetails;
          }

          if (
            item?.CICDetails?.[0]?.IQFileDetailsList?.length &&
            Object.keys(item?.CICDetails?.[0]?.IQFileDetailsList?.[0]?.IQDetails).length
          ) {
            IQFileDetailsList = item?.CICDetails?.[0]?.IQFileDetailsList?.[0]?.IQDetails;
          }

          if (
            item?.CICDetails?.[0]?.CPTFileDetailsList?.length &&
            Object.keys(item?.CICDetails?.[0]?.CPTFileDetailsList?.[0]?.CPTDetails).length
          ) {
            CPTFileDetailsList = item?.CICDetails?.[0]?.CPTFileDetailsList?.[0]?.CPTDetails;
          }
        }

        let _referenceDocumentsList = await getSupplierFileInfo(folderStructureWithoutVersion);
        //AWM-3059: pass the XFDF of the latest uploaded file only
        if (_referenceDocumentsList && Object.keys(_referenceDocumentsList).includes("XFDF")) {
          _referenceDocumentsList.XFDF = findLatestFile(_referenceDocumentsList.XFDF);
        }
        if (
          item &&
          item?.Task_Type === "Upload CIC" &&
          item?.DesignJobDetails?.[0]?.MatrixType === "CIC MATRIX AND CIC" &&
          item?.DesignJobDetails?.[0]?.XfdfFileList
        ) {
          _referenceDocumentsList.XFDFMatrix = [item?.DesignJobDetails?.[0]?.XfdfFileList?.[0]];
        }
        let copyXmlList = {};
        if (item?.Company && poaNumbers && poaNumbers?.length) {
          copyXmlList = await getCopyXmlSupplierFileInfo(poaNumbers, item?.Company);
        }

        for (let POANumbers in copyXmlList) {
          copyXmlList[POANumbers].forEach((copyXML) => {
            copyXML.isCopyXMLFile = true;
          });
        }

        if (copyXmlList && Object.keys(copyXmlList)?.length) {
          if (item?.CICDetails) {
            let tempObj = {};
            isArray(GABriefFiles) &&
              GABriefFiles.length &&
              (tempObj["GABriefFiles"] = GABriefFiles);
            isArray(OtherReferenceDocuments) &&
              OtherReferenceDocuments.length &&
              (tempObj["OtherReferenceDocuments"] = OtherReferenceDocuments);
            setReferenceDocumentsList({
              ..._referenceDocumentsList,
              ...copyXmlList,
              ...tempObj,
              ...RDTFileDetailsList,
              CCDFileDetailsList,
              IQFileDetailsList,
              CPTFileDetailsList
            });
          } else if (item?.CICMatrixDetails) {
            setReferenceDocumentsList({
              ..._referenceDocumentsList,
              ...copyXmlList,
              ...GABriefFiles,
              ...OtherReferenceDocuments,
              ...RDTFileDetailsList,
              CCDFileDetailsList,
              IQFileDetailsList,
              CPTFileDetailsList
            });
          } else {
            setReferenceDocumentsList({ ..._referenceDocumentsList, ...copyXmlList });
          }
        } else {
          if (item?.CICDetails) {
            let tempObj = {};
            isArray(GABriefFiles) &&
              GABriefFiles.length &&
              (tempObj["GABriefFiles"] = GABriefFiles);
            isArray(OtherReferenceDocuments) &&
              OtherReferenceDocuments.length &&
              (tempObj["OtherReferenceDocuments"] = OtherReferenceDocuments);
            setReferenceDocumentsList({
              ..._referenceDocumentsList,
              ...tempObj,
              ...RDTFileDetailsList,
              CCDFileDetailsList,
              IQFileDetailsList,
              CPTFileDetailsList
            });
          } else if (item?.CICMatrixDetails) {
            setReferenceDocumentsList({
              ..._referenceDocumentsList,
              ...GABriefFiles,
              ...OtherReferenceDocuments,
              ...RDTFileDetailsList,
              CCDFileDetailsList,
              IQFileDetailsList,
              CPTFileDetailsList
            });
          } else {
            setReferenceDocumentsList({ ..._referenceDocumentsList });
          }
        }
      }

      fetchSupplierFileInfo();
    }
  }, [loading, item]);

  // const User = useSelector((state) => state.UserReducer);
  // const userInformation = User.userInformation;
  // const [checkReadWriteAccess, setCheckReadWriteAccess] = useState(false);
  // useEffect(() => {
  //   if (User && item) {
  //     if (userInformation?.userid === item?.Assignee) {
  //       setCheckReadWriteAccess(true);
  //     } else {
  //       setCheckReadWriteAccess(false);
  //     }
  //   }
  // }, [User, item]);

  useEffect(() => {
    if (loadProofscope && toast.current) {
      toast.current.show({
        severity: "success",
        summary: "Proofscope File viewer",
        detail: "In progress... Please wait!",
        life: 100000,
      });
    }
    // Split the URL into key-value pairs
    const urlParts = item?.ApprovalID?.split("&");
    setApprovalId(urlParts?.[0]);
    setApprovalTaskId(urlParts?.[1]);
    setUserAssigned(urlParts?.[2]);
  }, [loadProofscope, userAssigned, item?.ApprovalID]);

  useEffect(() => {
    if (azureFile !== undefined && azureFile?.name !== undefined) {
      setFileName(azureFile?.name);
      // if (taskFolder === "CIC") {
      //   setFileDetails(azureFile);
      // }
    } else {
      setFileName("");
    }
  }, [azureFile]);

  useEffect(() => {
    setApprovedTaskList(item?.DesignJobDetails?.[0]?.ApprovedTaskList);
  }, [item?.DesignJobDetails?.[0]?.ApprovedTaskList]);

  const handleDownload = async () => {
    // Provide the necessary parameters to the downloadFile function

    const fileName = item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name; // Replace with the desired file name
    try {
      // Call the downloadFile function and wait for the result
      const result = await downloadAzureFileShare(fileName, buName, taskFolder);

      if (result) {
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "File Downloaded",
            detail: "Download completed successfully!",
            life: 3000,
          });
        }
      } else {
        // Show an error toast message
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "File Download Failed",
            detail: "Download failed. Please try again.",
            life: 3000,
          });
        }
      }
    } catch (error) {
      // Show an error toast message
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "An error occurred during file download. Please try again.",
          life: 3000,
        });
      }
    }
  };

  const env = getEnvironmentFromURL();
  const sanitizedBuName = sanitizeFileName(buName);
  const sanitizedTaskFolder = sanitizeFileName(taskFolder);
  const Assignee = item?.Assignee;
  const taskStatus = item?.Task_Status;

  useEffect(() => {
    if (
      item.Task_ID === TaskID &&
      (TaskID.includes("ARDT") || TaskID.includes("ACIC") || TaskID.includes("ACICMatrix"))
      // && (approvalStatus !== 'Approved')
    ) {
      setIsLoading(true);
      // Check if di_name exists
      const sanitizedFileUrl = sanitizeFileName(
        item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name,
      );

      // Generate the paths for PDF and XFDF
      const filename = item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name?.split(".")
        .slice(0, -1)
        .join(".");
      const fileExtension =
        item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name.split(".").pop();
      const sanitizeFile = replaceSpecialChars(filename);

      const pdfPath = `cloudflow://awm/${env}/${buName}/${taskFolder}/${ProjectID}/${DesignJobDetails.Design_Job_ID}/${item?.DesignJobDetails?.[0]?.FileMetaDataList[0].Version}/${sanitizeFile}.${fileExtension}`;
      const XFDFPath = `cloudflow://awm/${env}/${buName}/${taskFolder}/${ProjectID}/${DesignJobDetails.Design_Job_ID}/${item?.DesignJobDetails?.[0]?.FileMetaDataList[0].Version}/${sanitizeFile}.XFDF`;

      const xfdfVersion =
        item?.DesignJobDetails?.[0]?.XfdfFileList?.length &&
        item?.DesignJobDetails?.[0]?.XfdfFileList[0].Version !== "" &&
        item?.DesignJobDetails?.[0]?.XfdfFileList[0].Version !== "NaN"
          ? (parseInt(item?.DesignJobDetails?.[0]?.XfdfFileList[0].Version) + 1).toString()
          : "1";
      const XFDFAzureFolderStructure = `${folderStructure}/XFDF/${xfdfVersion}/`; //instead of version it will be xfdfVersion extracted from GET API response of Projectplan or TaskDetails
      const storeApproveFileDetailsFormData = {
        FileList: [
          {
            Filename: `${sanitizeFile}.XFDF`,
            Version: xfdfVersion,
            AWMTaskID: TaskID,
            Size: "",
            Filepath: "",
            Full_Name: `${userInformation.firstName} ${userInformation.lastName}`,
            Email: `${userInformation.userid}@pg.com`,
            JobID: DesignJobDetails.Design_Job_ID,
            JobName: DesignJobDetails.Design_Job_Name,
            TypeOfFile: "xfdf",
            ViewPFURL: "",
          },
        ],
      };

      // Async function to download and process XFDF
      const downloadAndProcessXFDF = async () => {
        try {
          const xfdfContent = await DownloadAnnotation(
            pdfPath,
            XFDFPath,
            `${sanitizeFile}.XFDF`,
            XFDFAzureFolderStructure,
            DesignJobDetails.Design_Job_Status,
            storeApproveFileDetailsFormData,
            ProjectID,
            toast,
            page1,
            page2,
            pageType,
            navigate,
            item,
            DesignJobDetails.XfdfFileList,
            approvalStatus,
          );
          // Download XFDF content
          if (xfdfContent.status === 500) {
            // setRejectionReasonError(
            //   `Unable to fetch rejection reasons from proofscope: ${xfdfContent.contents}`
            // );
            setRejectionReasonError(
              `Proofscope integration issue, markups might be out of sync, approval can be submitted. For rejections, please try again later.`,
            );
          }
          const extractedAnnotations = fetchExtractedAnnotations(xfdfContent); //AWM-3059: created a common function

          // Set the annotations in the state

          if (
            item?.RejectionReasons?.length
            // &&              item?.ApprovalID?.includes(item?.Assignee)
          ) {
            //AWM-3059: show markups without historical data
            const latestPegaMarkups = [];
            const latestProofscopeMarkups = [];
            extractedAnnotations.forEach((proofscopeObj) => {
              const filteredMarkup = item.RejectionReasons.filter((pegaObj) => {
                return pegaObj.MarkupID === proofscopeObj.markupId;
              });

              if (filteredMarkup.length) {
                latestPegaMarkups.push(filteredMarkup[0]);
              } else {
                latestProofscopeMarkups.push(proofscopeObj);
              }
            });

            const mergedMarkupss = mergePegaAndProofscopeMarkups(
              latestProofscopeMarkups,
              latestPegaMarkups,
            );
            setComments(sortMarkupsInDescendingOrder(mergedMarkupss));
          } else {
            const extractedAnnotationsModified = extractedAnnotations.map((annotation, index) => ({
              ...annotation,
              markUpDate: changeDateFormat(annotation.creationDate.substring(2)),
              owner: localStorage.getItem("userId"),
              count: index + 1,
            }));

            setComments(sortMarkupsInDescendingOrder(extractedAnnotationsModified));
          }
          // Set isLoading to false when done
          setIsLoading(false);
        } catch (error) {
          setComments([]);

          console.error("Error:", error.message);

          // Set isLoading to false on error
          setIsLoading(false);
        }
      };

      // Call the download and processing function
      setComments([]);
      downloadAndProcessXFDF();
    }
  }, [item]);

  const sortMarkupsInDescendingOrder = (data) => {
    return data?.sort((a, b) => {
      // Extract the version and last two decimal numbers from markupId
      const getVersion = (obj) => obj?.version;
      const getDecimalNumbers = (obj) => {
        const parts = obj?.markupId?.split(".");
        return parts?.slice(-2)?.map(Number);
      };

      const [versionA, decimalA] = [getVersion(a), getDecimalNumbers(a)];
      const [versionB, decimalB] = [getVersion(b), getDecimalNumbers(b)];

      // Sort by version in descending order
      if (versionA !== versionB) {
        return versionB - versionA;
      }

      // If versions are equal, sort by last two decimal numbers in descending order
      if (decimalA[0] !== decimalB[0]) {
        return decimalB[0] - decimalA[0];
      }

      return decimalB[1] - decimalA[1];
    });
  };

  const mergePegaAndProofscopeMarkups = (proofscopeMarkups, pegaMarkups) => {
    let tempPegaMarkups = [];
    pegaMarkups.map((pegaObj) => {
      tempPegaMarkups.push({
        markupId: pegaObj.MarkupID,
        type: "text",
        creationDate: "",
        content: pegaObj.Markup,
        role: pegaObj.ResponsibleFunctionRole,
        reason: pegaObj.Reason,
        defectType: pegaObj.DefectType,
        comment: pegaObj.Comment,
        taskId: pegaObj.AWM_Task_ID,
        version: pegaObj.VersionNumber,
        MarkupTaskID: "",
        owner: pegaObj.Assignee,
        markUpDate: changeDateFormat(pegaObj.MarkupDate),
      });
    });

    let newProofscopeMarkups = [];

    proofscopeMarkups.map((obj1) => {
      const filteredData = tempPegaMarkups.filter((obj2) => {
        return obj1.markupId === obj2.markupId;
      });
      if (filteredData.length === 0) {
        newProofscopeMarkups.push(obj1);
      }
    });

    const newProofscopeMarkupsExtraInfo = newProofscopeMarkups.map((obj1) => ({
      ...obj1,
      markUpDate: changeDateFormat(obj1.creationDate.substring(2)),
      owner: localStorage.getItem("userId"),
    }));

    let mergedMarkups = [...newProofscopeMarkupsExtraInfo, ...tempPegaMarkups];
    mergedMarkups.sort(customSort);

    const mergedMarkUpWithCount = mergedMarkups.map((markups, item) => ({
      ...markups,
      count: item + 1,
    }));
    return mergedMarkUpWithCount;
  };

  function customSort(a, b) {
    if (a.version === "" && b.version !== "") {
      return -1; // Place object with empty version on top
    } else if (a.version !== "" && b.version === "") {
      return 1;
    } else {
      return b.version - a.version; // Sort by descending version
    }
  }

  const handleViewProofScopeClick = async () => {
    // event.preventDefault();
    try {
      if (Assignee === "") {
        setAssignee("Not a valid user!");
      } else {
        setAssignee(""); // Sanitize various variables including fileUrl

        if (item?.PFFileURL === "" || userAssigned !== Assignee) {
          await initiateViewProofscope();
        }

        if (userInformation?.userid === Assignee && apporovalTaskId === item?.Task_ID) {
          if (approvalStatus === "") {
            await initiateViewProofscope();
          } else {
            if( checkCicCicmIsMarkupPresent) {
              await initiateViewProofscope();
            }
            console.log("User ID matches Assignee. Setting file content...");
            setFileContent(item?.PFFileURL);
            setVisible(true);
          }
        } else {
          console.log("User ID does not match Assignee. Setting readonly file content...");
          setFileContent(item?.ViewPFFileURL);
          setVisible(true);
        }
      }
    } catch (error) {
      console.error("Error in handleViewProofScopeClick:", error);
    }
  };

  const initiateViewProofscope = async () => {
    //Chekcing prod env
    // const filePath = `cloudflow://awm/${env}/${sanitizedBuName}/${sanitizedTaskFolder}/${sanitizedFileUrl}`;
    // let singleFilePath = "";
    let filePath = [];
    if (item?.DesignJobDetails?.[0]?.FileMetaDataList?.length) {
      item?.DesignJobDetails?.[0]?.FileMetaDataList.map((obj) => {
        let path = `cloudflow://awm/${env}/${sanitizedBuName}/${sanitizedTaskFolder}/${ProjectID}/${DesignJobDetails.Design_Job_ID}/${obj.Version}/${obj.File_Name}`;
        // let path= `cloudflow://awm/${env}/${sanitizedBuName}/${sanitizedTaskFolder}/${ProjectID}/${DesignJobDetails.Design_Job_ID}/${obj.Version}/${obj.File_Name.split('.pdf')[0]}_${obj.Version}.pdf`;
        // let path= `cloudflow://awm/${env}/${sanitizedBuName}/${sanitizedTaskFolder}/${obj.File_Name}`;
        filePath.push(path);
      });
    }

    if( checkCicCicmIsMarkupPresent) {
      CicCicmIsMarkupPresent = "Yes";
    }
    
    await viewProofScopeFile(
      ProjectID,
      item?.Task_Status,
      item?.Task_Key,
      TaskID,
      filePath,
      // item?.DesignJobDetails?.[0]?.FileMetaDataList?.length > 1 ? multipleFilePath : singleFilePath,
      // `cloudflow://awm/${env}/${sanitizedBuName}/${sanitizedTaskFolder}/${sanitizedFileUrl}`,
      Assignee,
      item?.FlowName,
      item?.FlowAction,
      // item?.DesignJobDetails?.[0]?.FileMetaDataList?.length
      filePath?.length,
      CicCicmIsMarkupPresent === "Yes" ? CicCicmIsMarkupPresent : "No",
    );

    console.log("viewProofScopeFile called. Setting visible.");
    setVisible(true);
  };
  const closeDialog = async () => {
    setVisible(false);
    await dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
  };

  let di_name;
  // if (!approve) {
  if (approvalStatus !== "Approved") {
    di_name =
      // version !== "V0" &&
      // item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.Timestamp !== ""
      // ? `${item?.Task_Name}_${version}`
      `${item?.Task_Name}`;
  }
  const allowedExtensions = [".pdf", ".zip", ".ai", ".postscript"];

  const onFileUpload = (e, fileDetails) => {
    let _totalSize = totalSize;
    let files = e.files;
    if (!files || !files[0]) {
      // Handle the case when no file is selected
      return;
    }

    const originalFile = files[0];
    const extension = originalFile?.name?.split(".").pop();
    const newFileName = `${originalFile?.name?.split(".").shift()}_${
      fileDetails.Version
    }.${extension}`;

    const renamedFile = new File([originalFile], newFileName, { type: originalFile?.type });

    setAzureFileUploadMsg(false);
    setFileExtMsg("");

    Object.keys(files).forEach((key) => {
      _totalSize += files[key].size || 0;
    });

    setTotalSize(_totalSize);
    renamedFile && setAzureFile(renamedFile);
    renamedFile?.name && setFileName(renamedFile.name);

    setVersion(fileDetails.Version);
    setFileDetails(fileDetails);
    if (!rejected) {
      setPageEdited(true);
    }
    if (setFileUploaded) {
      setFileUploaded(true);
    }
  };

  const onFileClear = () => {
    setAzureFile("");
    setTotalSize(0);
    setFileDetails(null);
    setformattedValue("");
    setVersion(0);
    setFileName("");
  };

  const DesignHeader = (di_name) => {
    return (
      <>
        <div
          style={{
            marginLeft: 20,
            padding: 5,
            width: "80%",
            wordWrap: "break-word",
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
          className="font-color"
        >
          {/* {approve ? `${item?.Task_Name}_${version}_${date}` : di_name} */}
          {approvalStatus === "Approved"
            ? // ? `${item?.Task_Name}_${version}`
              `${item?.Task_Name}`
            : di_name}
            { (TaskID?.includes("ACIC") || TaskID?.includes("ACICMatrix") || TaskID?.includes("ARDT") )&& (
              <>
                <Button
                  className={"button-layout email_share_button"}
                  variant="secondary"
                  onClick={() => handleEmailClick()}
                >
                  <span className="pi pi-share-alt" aria-hidden="true" />
                  <span>&nbsp;&nbsp;Share</span>
                </Button>
              </>
            )}
        </div>

        {(TaskID.includes("URDT") ||
          TaskID.includes("UCIC") ||
          (TaskID.includes("UCICMatrix") && item?.Task_Status === "Cancelled") ||
          ((TaskID.includes("ARDT") || TaskID.includes("ACIC") || TaskID.includes("ACICMatrix")) &&
            (approvalStatus !== "" || item?.Task_Status === "Cancelled"))) && (
          <div>
            {(approvalStatus === "Approved" ||
              approvalStatus === "Rejected" ||
              item?.Task_Status === "Cancelled") && (
              <img
                src={approvalStatus === "Approved" ? ApprovedIcon : RejectedIcon}
                alt="icon"
                height="18px"
                width="18px"
              ></img>
            )}
            <span
              className={`approval-status-text ${
                item?.Task_Status === "Cancelled" ? "Rejected" : approvalStatus
              }`}
            >
              {item?.Task_Status === "Complete-Rejected" ||
              item?.Task_Status === "Complete-Approved" ||
              item?.Task_Status === "Cancelled"
                ? item?.Task_Status
                : approvalStatus}
            </span>
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    if (TaskID.includes("ARDT") || TaskID.includes("ACIC") || TaskID.includes("ACICMatrix")) {
      const clonedComments = _.cloneDeep(comments);
      setTableData(clonedComments);
      if (!clonedComments?.length && setInitialTableData) {
        setInitialTableData([]);
      } else if (!InitialTableData?.length && setInitialTableData) {
        setInitialTableData(clonedComments);
      }
    }
  }, [comments]);

  useEffect(() => {
    if (TaskID.includes("ACIC") || TaskID.includes("ACICMatrix")) {
      const hasAtLeastOneMarkup =
        tableData?.some((obj) => obj?.content && String(obj.content).trim() !== "") || false;
      setAllRowsEdited(hasAtLeastOneMarkup);
    }
  }, [tableData]);

  const renderMappingBody = (options, rowData, index) => {
    let field = rowData.field;

    return (
      <>
        {field === "content" && (
          <>
            <span>{`${options?.count}. ${options[field]}`}</span>
          </>
        )}
        {field === "version" && (
          <>
            <span>
              {" "}
              {options[field] !== null && options[field] !== ""
                ? options[field]
                : item?.DesignJobDetails?.[0]?.FileMetaDataList?.length}
            </span>
          </>
        )}
        {field === "creationDate" && changeDateFormat(options[field])}

        {field !== "content" &&
          field !== "creationDate" &&
          field !== "version" &&
          options[field]}
      </>
    );
  };

  const processFileName = (file) =>
    file?.includes("/") ? file?.split("/").slice(1).join("/") : file;

  const dynamicColumns = () => {
    return [
      // <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />,
      columns.map((col, i) => (
        <Column key={i} field={col.field} header={col.header} body={renderMappingBody} />
      )),
    ];
  };

  const ORDAssetsHeader = (
    <>
      <div
        style={{
          marginLeft: 20,
          padding: 5,
        }}
        className="ubd-accordion-header"
      >
        Other Reference Documents & Assets
      </div>
      <div
        className="add-file-ubd"
        onClick={() => otherRDAddNewEmptyDesign()}
        disabled={item?.Task_Status === "Complete" || item?.Task_Status === "Cancelled" || !checkReadWriteAccess}
      >
        <img
          src={plusCollapseImg}
          alt="filter logo"
          className="heade-plus-icon"
          disabled={item?.Task_Status === "Complete" || item?.Task_Status === "Cancelled" || !checkReadWriteAccess}
        />{" "}
        Add Files
      </div>
    </>
  );

  const handleEmailClick = () => {
    const readonlyProofScopeUrl = item?.ViewPFFileURL || item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.ReadOnlyURL || "";
    // Open Outlook with new email with default content
    const subject = '---';
    const body = `\n${readonlyProofScopeUrl}\n\nBest regards`;
    
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return (
    <div>
      {!visible && <Toast ref={toast} />}
      <div className="design-intent-header">{DesignHeader(di_name)}</div>
      {TaskID.includes("ACIC") && (
        <div>
          {item?.CICDetails ? (
            <div className="upload-cic-pmp-wrapper">
              [{item?.CICDetails.length}]{" "}
              {item?.CICDetails.length > 1 ? "PMP's in scope" : "PMP in scope"}:{" "}
              {item?.CICDetails.map((item, index) => (
                <span key={item.PMPNumber}>
                  {index > 0 && ", "}
                  {item.PMPNumber}
                </span>
              ))}
            </div>
          ) : item?.CICMatrixDetails ? (
            <div className="upload-cic-pmp-wrapper">
              [{item?.CICMatrixDetails.length}]{" "}
              {item?.CICMatrixDetails.length > 1 ? "PMP's in scope" : "PMP in scope"}:{" "}
              {item?.CICMatrixDetails.map((item, index) => (
                <span key={item.PMPNumber}>
                  {index > 0 && ", "}
                  {item.PMPNumber}
                </span>
              ))}
            </div>
          ) : (
            ""
          )}
        </div>
      )}
      {upload && (
        <>
          <div
            style={{
              marginLeft: 20,
              padding: 5,
            }}
          >
            <FileUploadManager
              taskdata={
                item?.DesignJobDetails?.[0]?.FileMetaDataList !== undefined
                  ? item?.DesignJobDetails?.[0]?.FileMetaDataList
                  : ""
              }
              onFileUpload={onFileUpload}
              onFileClear={onFileClear}
              subFolder={taskFolder}
              rejected={rejected}
              setFormObjects={setFormObjects}
              setPageEdited={setPageEdited}
              pageEdited={pageEdited}
              accept={allowedExtensions}
              taskStatus={item?.Task_Status}
              checkReadWriteAccess={checkReadWriteAccess}
              // maxSize={2000000000}
            />
          </div>
        </>
      )}
      <div className="ps-error-msg">
        {azureFileUploadMsg && <Message severity="error" text={thumbnailErrorMsg} />}
      </div>
      {/* Other Reference Documents & Assets */}
      {toShowORDA && (
        <>
          <div className="design-intent-header">{ORDAssetsHeader}</div>
          {otherRefernceDocsForUI?.map((group, groupIdx) => (
            <UploadBriefingDocuments
              key={`group-${groupIdx}`}
              azureSubFolder={AzureSubFolder}
              item={group?.FileMetaDataList}
              pageEdited={pageEdited}
              setPageEdited={setPageEdited}
              checkReadWriteAccess={checkReadWriteAccess}
              fileUploadSection="Other Reference Documents & Assets"
              disableDelete={
                taskStatus === "Complete" ||
                taskStatus === "Cancelled" ||
                (otherRefernceDocsForUI?.length === 1 && otherRefernceDocsForUI[0].FileMetaDataList[0].File_Name === "") ||
                !checkReadWriteAccess
              }
              taskStatus={taskStatus}
              onFileUpload={onORDAFileUpload}
              onFileClear={onORDAFileClear}
              sequence={group?.Sequence}
            />
          ))}
        </>
      )}
      <div className="approve-design-intent">
        {toShowReferenceDocuments && (
          <div className="supplier-file-list-container">
            <div className="supplier-file-list-heading">Reference Documents</div>
            <FileListContainer
              supplierFileList={referenceDocumentsList}
              subFolder={taskFolder}
              companyName={item?.Company}
            />
          </div>
        )}

        <div class="row_task_detail">
          <div class="column_task_detail">
            {showApprovedTaskList && (
              <p className="vpn-warning">
                Please ensure you are connected to the VPN before opening the file.
              </p>
            )}
            <>
              {approve && (
                <div
                  style={{
                    marginLeft: 20,
                    padding: 5,
                  }}
                >
                  <div className="card flex justify-content-center">
                    <Dialog
                      header={
                        isError ? (
                          <span className="text-danger">Error</span>
                        ) : (
                          replaceSpecialChars(
                            item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name,
                          )
                        )
                      }
                      visible={visible}
                      maximizable
                      maximized
                      style={{ width: loadProofscope ? "70vw" : "50vw" }}
                      onHide={closeDialog}
                    >
                      {isError ? (
                        <>{message}</>
                      ) : loadProofscope && item?.PFFileURL === "" ? (
                        <h4>Please wait!!! Proofscope file loading....</h4>
                      ) : (
                        <iframe
                          src={fileContent}
                          title="File Content"
                          style={{ width: "100%", height: "500px" }}
                          onLoad={() => {
                            // Content has loaded
                            setVisible(true);
                          }}
                        />
                      )}
                    </Dialog>
                  </div>
                  {item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name === "" ? (
                    fileName === "" ? (
                      `No files uploaded yet please upload file!`
                    ) : (
                      ``
                    )
                  ) : (
                    <div>
                      <a
                        className="flex flex-column text-left"
                        disabled={loadProofscope}
                        onClick={(event) => {
                          if (loadProofscope) {
                            event.preventDefault();
                          } else {
                            handleViewProofScopeClick();
                          }
                        }}
                      >
                        {/* Ask are we going to show image */}
                        {item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Path && (
                          <img
                            src={item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Path}
                            alt="Image"
                            width="80"
                            height="60"
                          />
                        )}
                        <div>
                          <br />
                          {fileName && item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name
                            ? replaceSpecialChars(
                                processFileName(fileName) ||
                                  processFileName(
                                    item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name,
                                  ),
                              )
                            : replaceSpecialChars(
                                fileName ||
                                  item?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]?.File_Name,
                              )}
                          <br />
                          {assignee && <p className="error-text">{assignee}</p>}
                        </div>
                      </a>
                    </div>
                  )}
                </div>
              )}
            </>
          </div>
          {showApprovedTaskList && (
            <div class="column_task_detail">
              <Container>
                <DataTable
                  stripedRows
                  size={"small"}
                  scrollable
                  className="mt-3"
                  tableStyle={{
                    width: "max-content",
                    minWidth: "100%",
                  }}
                  value={approvedTaskList}
                  emptyMessage="Nothing to show"
                >
                  {dynamicColumns_approvedTaskList()}
                </DataTable>
              </Container>
            </div>
          )}
        </div>
      </div>

      {(TaskID.includes("ARDT") || TaskID.includes("ACIC") || TaskID.includes("ACICMATRIX")) && (
          <>
            {isLoading ? (
              <div>Loading...</div>
            ) : (
              <>
                <div className="ps-error-msg">
                  {rejectionReasonError && <Message severity="warn" text={rejectionReasonError} />}
                </div>
                {comments.length > 0 && (
                  <div>
                    <div className="design-intent-header font-color">
                      <div className="rejection-reason-header">Rejection Reasons</div>
                    </div>
                    <div className="rejection-table">
                      <div>
                        <DataTable
                          stripedRows
                          size={"small"}
                          selectionMode="checkbox"
                          scrollable
                          responsiveLayout="scroll"
                          className="mt-3"
                          tableStyle={{
                            width: "max-content",
                            minWidth: "100%",
                          }}
                          value={tableData}
                          emptyMessage="Please add annotations in case of approval rejections"
                        >
                          {dynamicColumns()}
                        </DataTable>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
    </div>
  );
};

export default UploadDesignIntentProofscope;
